import useSWR from "swr";
import axios, { AxiosError } from "axios";
import { uniqBy } from "lodash";

import { Option } from "models/Option";
import { TurvoUserDto } from "models/dto/TurvoUserDto";

const emptyAccountOwners: TurvoUserDto[] = [];

export const useGetAccountOwners = () => {
  const { data, error, isLoading } = useSWR<TurvoUserDto[], AxiosError>(
    "/api/carriers/accountOwners",
    (url) => axios.get<TurvoUserDto[]>(url).then((response) => response.data),
    { keepPreviousData: true, revalidateOnFocus: false }
  );

  return {
    data: data ?? emptyAccountOwners,
    error,
    isLoading,
  };
};

export const getAccountOwnerOptions = (
  accountOwners: TurvoUserDto[],
  selectedAccountOwners: Option<string>[]
): Option<string>[] =>
  uniqBy(
    [
      ...accountOwners.reduce<Option<string>[]>((acc, accountOwner) => {
        if (accountOwner.id && accountOwner.name) {
          acc.push({
            key: accountOwner.id,
            value: accountOwner.id,
            text: accountOwner.name,
          });
        }
        return acc;
      }, []),
      ...selectedAccountOwners,
    ],
    (option) => option.key
  ).sort((a, b) => a.text.localeCompare(b.text));
